export enum ActionTypes {
    APPLY_THEME = 'browser-module/apply-theme',
}
